export default [
  {
    "id": "home",
    "name": "home",
    "path": "/"
  },
  {
    "id": "allCategories",
    "name": "todas-categorias",
    "path": "/categorias/"
  },
  {
    "id": "allSubcategories",
    "name": "todas-subcategorias",
    "path": "/subcategorias/"
  },
  {
    "id": "allBrands",
    "name": "todas-marcas",
    "path": "/marcas/"
  },
  {
    "id": "product",
    "name": "produto",
    "path": "/:slug/p/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "buybox",
    "name": "buybox",
    "path": "/:slug/m/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "404",
    "name": "not-found",
    "path": "/404/"
  },
  {
    "id": "404",
    "name": "internal-not-found-page",
    "path": "/error-404/"
  },
  {
    "id": "500",
    "name": "error",
    "path": "/500/"
  },
  {
    "id": "500",
    "name": "internal-error-page",
    "path": "/error-500"
  },
  {
    "id": "review-list",
    "name": "review-list",
    "path": "/review/:productId/:slug/:categoryId/:subCategoryId/"
  },
  {
    "id": "rate-product",
    "name": "rate-product",
    "path": "/r/:slug/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "promoter-offer",
    "name": "promoter-offer",
    "path": "/:slug/divulgador/oferta/:productId/:categoryId/:subCategoryId/"
  },
  {
    "id": "seller-profile",
    "name": "seller-profile",
    "path": "/lojista/:sellerId"
  },
  {
    "id": "search",
    "name": "busca",
    "path": "/busca/:?term/"
  },
  {
    "id": "subcategory",
    "name": "subcategoria",
    "path": "/:slug1/:slug2/s/:categoryId/:subCategoryId/:?pFilters"
  },
  {
    "id": "category",
    "name": "categoria",
    "path": "/:slug1/l/:categoryId/:?pFilters"
  },
  {
    "id": "selection",
    "name": "selecao",
    "path": "/selecao/:selectionId/"
  },
  {
    "id": "max-security",
    "name": "max-security",
    "path": "/estaticas/seguranca-maxima/"
  },
  {
    "id": "brand",
    "name": "marca",
    "path": "/marcas/:brandId/"
  }
]
